import React from 'react';
import Header from '../components/DashHead';
import Footer from '../components/Footer';

function DashReports() {
    return (
        <div>
            <Header />
            Hello Reports
            <Footer />
        </div>
    );
}

export default DashReports;
